function initPastEventsLoadMore() {
  var list = document.querySelector('[data-past-list]');
  var button = document.querySelector('[data-past-load-more]');

  if (!list || !button) {
    return;
  }

  var pageSize = parseInt(list.getAttribute('data-past-page-size'), 10) || 5;

  button.addEventListener('click', function () {
    var hidden = list.querySelectorAll('[data-past-item].is-hidden');
    var limit = Math.min(pageSize, hidden.length);

    for (var i = 0; i < limit; i += 1) {
      hidden[i].classList.remove('is-hidden');
    }

    if (list.querySelectorAll('[data-past-item].is-hidden').length === 0) {
      button.hidden = true;
    }
  });
}

function renderModalDescription(container, raw) {
  if (!container) {
    return;
  }

  container.innerHTML = '';

  var parts = String(raw || '')
    .split('|||')
    .map(function (part) {
      return part.trim();
    })
    .filter(Boolean);

  if (!parts.length) {
    return;
  }

  parts.forEach(function (part) {
    var paragraph = document.createElement('p');
    paragraph.textContent = part;
    container.appendChild(paragraph);
  });
}

export default function initIstochnikSilPage() {
  initPastEventsLoadMore();

  var modal = document.getElementById('modal-istochnik-sil-event');

  if (!modal) {
    return;
  }

  var titleEl = modal.querySelector('#istochnik-sil-modal-title');
  var descriptionEl = modal.querySelector('[data-istochnik-sil-description]');
  var dateEl = modal.querySelector('#istochnik-sil-modal-date');

  document.addEventListener('click', function (event) {
    var button = event.target.closest('.istochnik-sil-event__details[data-modal-open]');

    if (!button) {
      return;
    }

    if (titleEl) {
      titleEl.textContent = button.dataset.title || '';
    }

    renderModalDescription(descriptionEl, button.dataset.description || '');

    if (dateEl) {
      dateEl.textContent = button.dataset.date || '';
    }

    if (descriptionEl) {
      descriptionEl.scrollTop = 0;
    }
  }, true);
}



// WEBPACK FOOTER //
// ./scripts/components/istochnik-sil/init.js